import { useQuery } from "react-query";

import { API_URL, LEGACY_GOOGLE_MAPS_API_KEY } from "../config";
import { DEFAULT_GOOGLE_MAPS_MAP_ID } from "../constants";

export type GoogleMapsRuntimeConfig = {
  googleMapsApiKey: string | null;
  googleMapsMapId: string;
  googleMapsLightMapId: string | null;
  googleMapsDarkMapId: string | null;
};

type RuntimeConfigResponse = {
  googleMapsApiKey?: string | null;
  googleMapsMapId?: string | null;
  googleMapsLightMapId?: string | null;
  googleMapsDarkMapId?: string | null;
};

const normalizeOptionalString = (value: unknown): string | null => {
  if (typeof value !== "string") {
    return null;
  }
  const normalized = value.trim();
  return normalized.length ? normalized : null;
};

const fetchGoogleMapsRuntimeConfig = async (): Promise<GoogleMapsRuntimeConfig> => {
  const res = await fetch(`${API_URL}/runtime-config`, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  const payload: RuntimeConfigResponse = await res.json();
  return {
    googleMapsApiKey:
      normalizeOptionalString(payload?.googleMapsApiKey) ||
      LEGACY_GOOGLE_MAPS_API_KEY,
    googleMapsMapId:
      normalizeOptionalString(payload?.googleMapsMapId) ||
      DEFAULT_GOOGLE_MAPS_MAP_ID,
    googleMapsLightMapId: normalizeOptionalString(payload?.googleMapsLightMapId),
    googleMapsDarkMapId: normalizeOptionalString(payload?.googleMapsDarkMapId),
  };
};

const useGoogleMapsApiKey = () =>
  useQuery<GoogleMapsRuntimeConfig, Error>(["runtime-config", "google-maps"], fetchGoogleMapsRuntimeConfig, {
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
  });

export default useGoogleMapsApiKey;
